module.exports = __webpack_public_path__ + "static/media/guide_img2_1.ad061d1c.png";